
import Vue from 'vue';
import { TranslateResult } from 'vue-i18n/types';

import { routesNames } from '@/router';

import UserReviews from '@/components/home/UserReviews.vue';
import ContactForm from '@/components/general/utils/ContactForm.vue';

import UTILS from '@/store/modules/UtilityModule';
import MISC_DATA from '@/store/modules/MiscDataModule';

export default Vue.extend({
	name: 'LongTermRent',

	components: { ContactForm, UserReviews },

	mixins: [],

	data() {
		return {
			our_colors: ['cyan123', 'orange123', 'pink123'],
			top_panel_idx: 0
		};
	},

	computed: {
		UTILS: () => UTILS,
		MISC_DATA: () => MISC_DATA,

		isMobile(): boolean {
			return this.$vuetify.breakpoint.mdAndDown;
		},

		topSectionHeight(): number {
			if (this.$vuetify.breakpoint.xs) {
				// Smartphone only
				return 460;
			}
			return 600;
		},

		topBulletpoints(): TranslateResult {
			return this.$t('long_rent.top_section.bps');
		},

		advantages(): any {
			return [
				{
					title: this.$t('long_rent.why_section.advantages.1.title'),
					text: this.$t('long_rent.why_section.advantages.1.text', {
						price: this.$n(this.MISC_DATA.prices.deposit, 'currencyShort')
					}),
					color: 'orange123',
					hide_mobile: false
				},
				{
					title: this.$t('long_rent.why_section.advantages.2.title'),
					text: this.$t('long_rent.why_section.advantages.2.text'),
					color: 'pink123',
					hide_mobile: true
				},
				{
					title: this.$t('long_rent.why_section.advantages.3.title'),
					text: this.$t('long_rent.why_section.advantages.3.text'),
					color: 'orange123',
					hide_mobile: false
				},
				{
					title: this.$t('long_rent.why_section.advantages.4.title'),
					text: this.$t('long_rent.why_section.advantages.4.text'),
					color: 'cyan123',
					hide_mobile: false
				}
			];
		},

		howSectionPoints(): TranslateResult {
			return this.$t('long_rent.how_section.points');
		},

		panelsBulletpoints(): TranslateResult {
			return this.$t('long_rent.top_section.panels.bps');
		},

		prices(): any {
			return this.MISC_DATA?.basedata?.ltr;
		},

		panelPrice(): number[] {
			return this.prices.panel;
		},

		truckMockups(): any {
			return this.MISC_DATA.data_per_bu.images.truck_side_mockups;
		},

		dialogContact(): boolean {
			return this.$route.query.dialog === 'dialog-ltr-contact';
		}
	},
	mounted() {
		const longTermRentAvailable = this.MISC_DATA.data_per_bu?.long_term_rent_allowed;

		if (!longTermRentAvailable) {
			this.$router.replace({ name: routesNames.home });
		}

		if (this.$isDomain('de')) {
			this.top_panel_idx = 1;
		}
	}
});
